import { useContext } from 'react';
import { ResponsiveContext } from '../../utils/responsive.es.js';

var useDevice = function useDevice() {
  var state = useContext(ResponsiveContext);
  return state.device;
};

export { useDevice };